import { ReactNode } from "react"
import styled from "@emotion/native"
import Animated, { FadeInUp, FadeOutUp, LinearTransition } from "react-native-reanimated"

type ExpandableProps = {
  children: ReactNode
  isVisible: boolean
}

export function Expandable({ children, isVisible }: ExpandableProps) {
  return (
    isVisible && (
      <MainContainer>
        <AnimatedContent
          entering={FadeInUp.delay(200).duration(400)}
          exiting={FadeOutUp.duration(300)}
          layout={LinearTransition.springify()}
        >
          {children}
        </AnimatedContent>
      </MainContainer>
    )
  )
}

const MainContainer = styled.View`
  flex: 1;
  min-height: 0;
  justify-content: flex-start;
  align-items: stretch;
`

const AnimatedContent = styled(Animated.View)`
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow: hidden;
`
